import {
  MESSAGES_PERMISSION,
  NEWSFEED_PERMISSION,
} from '@app/core/constants/permissions.constants';
import { Permission } from '@app/core/models/permissions.interface';
import { NavRoute, NavItems } from './navigation.interface';

export const NAV_ITEMS: NavItems = [
  {
    type: 'route',
    name: 'Home',
    route: 'home',
    icon: 'home',
  },
  {
    type: 'route',
    name: 'Messages',
    route: 'communication',
    icon: 'comment-alt-lines',
    permission: MESSAGES_PERMISSION,
  },
  {
    type: 'route',
    icon: 'tasks',
    name: 'Tasks',
    route: 'tasks',
    access: 'canAccessTasks$',
  },
  {
    type: 'route',
    name: 'Check-In',
    route: 'daily-labor-checkin',
    icon: 'clipboard-check',
    permission: Permission.CanAccessDailyLaborCheckIn,
  },
  {
    type: 'route',
    name: 'Housekeeping Tools',
    shortName: 'Housekeeping',
    route: 'housekeeping-tools',
    icon: 'bed',
    access: 'canAccessHousekeepingTools$',
  },
  {
    type: 'route',
    name: 'Schedules',
    route: 'scheduler',
    icon: 'calendar-alt',
    permission: Permission.CanAccessSchedulerAndAddEditShifts,
  },
  {
    type: 'route',
    name: 'Shift Swap Requests',
    shortName: 'Shift Swap',
    route: 'shift-swap-requests',
    icon: 'random',
    access: 'canAccessShiftSwapRequests$',
  },
  {
    type: 'route',
    name: 'Reports',
    route: 'reports',
    icon: 'chart-bar',
    permission: Permission.CanAccessRealtimeHotelLaborAnalyzer,
  },
  {
    type: 'route',
    name: 'Newsfeed',
    route: 'newsfeed',
    icon: 'newspaper',
    permission: NEWSFEED_PERMISSION,
  },
  {
    type: 'route',
    name: 'User Profile',
    shortName: 'Profile',
    route: 'user-profile',
    icon: 'user',
  },
  {
    type: 'link',
    name: 'Help Center',
    shortName: 'Help',
    link: 'https://help.hoteleffectiveness.com/360747',
    icon: 'question-circle',
  },
  {
    type: 'link',
    name: 'Contact Us',
    shortName: 'Contact',
    link: 'https://help.hoteleffectiveness.com/contact-us',
    icon: 'envelope',
  },
  {
    type: 'route',
    name: 'Sign Out',
    route: 'logout',
    icon: 'sign-out',
  },
];

export const MORE_TAB: NavRoute = {
  type: 'route',
  name: 'More',
  route: 'more?fromThumbNav=true',
  icon: 'ellipsis-h-alt',
};
